// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ModalContent-module__modalContent___21xL9","content":"ModalContent-module__content___dDp03"};